module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-time-display"
  }, [_c('div', {
    staticClass: "mu-time-display-text"
  }, [_c('div', {
    staticClass: "mu-time-display-affix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-time-display-time"
  }, [_c('span', {
    staticClass: "mu-time-display-clickable",
    class: {
      'inactive': _vm.mode === 'minute'
    },
    on: {
      "click": _vm.handleSelectHour
    }
  }, [_vm._v(_vm._s(_vm.sanitizeTime[0]))]), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "mu-time-display-clickable",
    class: {
      'inactive': _vm.mode === 'hour'
    },
    on: {
      "click": _vm.handleSelectMin
    }
  }, [_vm._v(_vm._s(_vm.sanitizeTime[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "mu-time-display-affix"
  }, [(_vm.format === 'ampm') ? _c('div', {
    staticClass: "mu-time-display-clickable",
    class: {
      'inactive': _vm.affix === 'am'
    },
    on: {
      "click": function($event) {
        _vm.handleSelectAffix('pm')
      }
    }
  }, [_vm._v("\n        PM\n      ")]) : _vm._e(), _vm._v(" "), (_vm.format === 'ampm') ? _c('div', {
    staticClass: "mu-time-display-clickable mu-time-display-affix-top",
    class: {
      'inactive': _vm.affix === 'pm'
    },
    on: {
      "click": function($event) {
        _vm.handleSelectAffix('am')
      }
    }
  }, [_vm._v("\n        AM\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82e20a12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/timePicker/timeDisplay.vue
// module id = 461
// module chunks = 1